import React from 'react';
import PropTypes from 'prop-types';

export default function ExternalLink({ width, height, color }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width={width} height={height} fill={color}>
      <path d='M213.3 128v42.7H106.7V405.3H341.3V298.7H384v128c0 5.7-2.2 11.1-6.2 15.1s-9.4 6.2-15.1 6.2H85.3c-5.7 0-11.1-2.2-15.1-6.2s-6.2-9.4-6.2-15.1V149.3c0-5.7 2.2-11.1 6.2-15.1s9.4-6.2 15.1-6.2h128zM448 64V234.7H405.3V136.8L239.1 303.1l-30.2-30.2L375.1 106.7H277.3V64H448z'/>
    </svg>
  );
}

ExternalLink.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

ExternalLink.defaultProps = {
  width: 14,
  height: 14,
  color: 'currentColor',
};
